module.exports = __webpack_public_path__ + "media/images/athletes/3533-7d80f42134cb1c807f5ea31b6b5339ee.png";